// extracted by mini-css-extract-plugin
module.exports = {"textMargin":"CountrySelector_textMargin__DRSU7","image":"CountrySelector_image__ylfd8","text":"CountrySelector_text__rsg_A"};